const version = '5.21.2';
export { version };
